import CoreuiController from "../lib/coreui-controller"
import Stepper from "../coreui/stepper"

export default class CoreuiStepperController extends CoreuiController {
  static Component = Stepper
}
